<template>
  <div class="ps_msgBox">
    <div class="ps_msg_success" v-if="successCodes.includes(code)">
      <img src="@/assets/Success.png" alt="" />
      <div class="success_text">
        {{ $t("message.DataRegistration.Taxi.paid") }}
      </div>
    </div>
    <div class="ps_msg_failed" v-else-if="!normalCode.includes(code)">
      <div class="failed_text">
        <i class="el-icon-warning"></i>
        <span>{{ $t("message.DataRegistration.Taxi.canNotPay") }}</span>
      </div>
      <div class="failed_reason">
        {{ $t("message.DataRegistration.Taxi.reason") }}{{ spResult }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // props: ["code", "normalCode", "successCodes", "spResult"],
  props: {
    code: String,
    normalCode: {
      type: Array,
      default: () => {
        return [];
      },
    },
    successCodes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    spResult: String,
  },
};
</script>

<style lang="scss" scoped>
.ps_msgBox {
  max-width: 750px;
  margin: auto;
}
.ps_msg_success {
  background: #f9fef1;
  border: 1px solid #d8fba3;
  padding: 30px 15px;
  text-align: center;
  margin: auto;
  border-radius: 5px;
  .success_text {
    color: #70b606;
    font-size: 22px;
    margin-top: 20px;
  }
}
</style>